export default function SanitizeHTML({ html }) {
  const regex = /(<([^>]+)>)/gi;
  return html.replace(regex, '');
}
